import { render } from "./Home.vue?vue&type=template&id=3fe00ad0&scoped=true"
import script from "./home.js?vue&type=script&lang=js"
export * from "./home.js?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3fe00ad0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe00ad0"]])

export default __exports__